import React from "react";
import { toast } from "react-hot-toast";

export const toastSuccess = (message) => {
  toast.success(message || "Operation successful!");
};

export const toastWarning = (message) => {
  toast(message || "Warning!", {
    icon: "⚠️",
    style: {
      borderRadius: "10px",
      background: "#fff3cd",
      color: "#856404",
    },
  });
};

export const toastInfo = (message) => {
  toast(message || "Information", {
    icon: "ℹ️",
    style: {
      borderRadius: "10px",
      background: "#cce5ff",
      color: "#004085",
    },
  });
};

export const toastError = (message, setPlans) => {
  const errorMessage = message?.response?.data?.message
    ? message?.response?.data?.message
    : message?.response?.message
    ? message?.response?.message
    : message?.message
    ? message?.message
    : message;

  toast.error(errorMessage || "Something went wrong.");
};

// Render an error-styled toast that can include a clickable link
export const toastErrorWithLink = (text, url, linkText = "Open link") => {
  if (!url) {
    toast.error(text || "Something went wrong.");
    return;
  }
  toast.error(
    <span>
      {text}{" "}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "underline", color: "#2563EB" }}
      >
        {linkText}
      </a>
    </span>
  );
};

export const toastLocalError = (error, setPlans) => {
  const errorMessage = error?.response?.data?.apierror?.message
    ? error?.response?.data?.apierror?.message
    : error?.response?.data?.message
    ? error?.response?.data?.message
    : error?.response?.message
    ? error?.response?.message
    : error?.message
    ? error?.message
    : error;

  if (
    errorMessage === "Internal error: 'NoneType' object is not subscriptable"
  ) {
    setPlans(0);
    localStorage.setItem("chat-step", 0);
    return;
  }
  toast.error(errorMessage || "Something went wrong.");
};
